import { createContext, useState } from 'react'

import { IBrandsResponseDTO } from '../../sdk/brand/brand.types'
import { ICompanyProductionStep } from '../../sdk/company-production-steps/company-production-steps.types'
import {
  IFinishedItemCategory,
  IFinishedItemProfileStatisticsResponse,
  IItemWithFinishedItemProfile,
} from '../../sdk/finished-item-profile/finished-item-profile.types'
import { sdk } from '../../services/sdk'

interface QRCodeDataContext {
  brands: IBrandsResponseDTO[]
  finishedItemCategories: IFinishedItemCategory[]
  itemWithfinishedItemProfile?: IItemWithFinishedItemProfile
  companyProductionStep?: ICompanyProductionStep
  statistics?: IFinishedItemProfileStatisticsResponse

  loading: boolean

  actions: {
    getBrands: () => Promise<void>
    getFinishedItemCategories: () => Promise<void>
    getFininishedItemProfile: (code: string) => Promise<void>
    getCompanyProductionStep: (stepId: string) => Promise<void>
    getStatistics: () => Promise<void>
  }
}

interface QRCodeProviderProps {
  children: React.ReactNode
}

export const QRCodeContext = createContext({} as QRCodeDataContext)

export function QRCodeProvider(props: QRCodeProviderProps) {
  const [loading, setLoading] = useState(false)

  const [brands, setBrands] = useState<IBrandsResponseDTO[]>([])
  const [finishedItemCategories, setFinishedItemCategories] = useState<
    IFinishedItemCategory[]
  >([])
  const [itemWithfinishedItemProfile, setItemWithfinishedItemProfile] =
    useState<IItemWithFinishedItemProfile>()
  const [companyProductionStep, setCompanyProductionStep] =
    useState<ICompanyProductionStep>()
  const [statistics, setStatistics] =
    useState<IFinishedItemProfileStatisticsResponse>()

  const getBrands = async () => {
    const response = await sdk.brand.getBrands()

    setBrands(response)
  }

  const getFinishedItemCategories = async () => {
    try {
      const response = await sdk.finishedItemProfile.getCategories()

      setFinishedItemCategories(response)
    } catch (err) {}
  }

  const getFininishedItemProfile = async (code: string) => {
    setLoading(true)
    try {
      const response =
        await sdk.finishedItemProfile.getFinishedItemProfile(code)

      setItemWithfinishedItemProfile(response)
    } catch (e) {
    } finally {
      setLoading(false)
    }
  }

  const getCompanyProductionStep = async (stepId: string) => {
    setLoading(true)
    try {
      const response =
        await sdk.companyProductionSteps.getCompanyProductionStepAssets(stepId)

      setCompanyProductionStep(response)
    } catch (e) {
    } finally {
      setLoading(false)
    }
  }

  const getStatistics = async () => {
    try {
      const response = await sdk.finishedItemProfile.getStatistics()
      setStatistics(response)
    } catch (e) {}
  }

  return (
    <QRCodeContext.Provider
      value={{
        brands,
        finishedItemCategories,
        itemWithfinishedItemProfile,
        companyProductionStep,
        statistics,
        loading,

        actions: {
          getBrands,
          getFinishedItemCategories,
          getFininishedItemProfile,
          getCompanyProductionStep,
          getStatistics,
        },
      }}
    >
      {props.children}
    </QRCodeContext.Provider>
  )
}
